import { useNavigate } from "react-router-dom";
import { styled } from '@mui/material/styles';
import { Box, ButtonBase, Typography } from '@mui/material';
import colors from '../theme/colors';

const images = [
    { url: "1.jpg", title: "Drenaż limfattyczny", id: "drenaz" },
    { url: "2.jpg", title: "Bańka chińska", id: "banka" },
    { url: "3.jpg", title: "Viofor", id: "viofor" },
    { url: "4.jpg", title: "Masaż", id: "masaz" },
    { url: "5.jpg", title: "Lipolaser", id: "lipolaser" },
    { url: "8.jpg", title: "Konchowanie uszu", id: "konchowanie" },
    { url: "7.jpg", title: "Fala uderzeniowa", id: "fala" },
];

const ImageButton = styled(ButtonBase)(({ theme }) => ({
    position: 'relative',
    height: 200,
    width: '100%',
    borderRadius: 4,
    overflow: 'hidden',

    [theme.breakpoints.down('sm')]: {
        height: 120,
    },

    '&:hover, &.Mui-focusVisible': {
        zIndex: 1,
        '& .MuiImageBackdrop-root': {
            opacity: 0.15,
        },
        '& .MuiImageMarked-root': {
            opacity: 0,
        },
        '& .MuiTypography-root': {
            border: '4px solid currentColor',
            borderRadius: 4,
            borderColor: colors.lightPink,
            fontWeight: 'bold',
        },
    },
}));

const ImageSrc = styled('span')({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
});

const Image = styled('span')(({ theme }) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    textAlign: 'center',
}));

const ImageBackdrop = styled('span')(({ theme }) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create('opacity'),
}));

const ImageMarked = styled('span')(({ theme }) => ({
    height: 3,
    width: 18,
    backgroundColor: colors.lightPink,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
}));

function Buttons() {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                px: { xs: 2, sm: 4, md: 6 },
                py: 4,
                gap: 2,
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
            }}
        >
            {images.map((image) => (
                <ImageButton
                    key={image.title}
                    onClick={() => navigate(`/services#${image.id}`)}
                    focusRipple
                    sx={{
                        flex: { xs: "1 1 100%", sm: "1 1 45%", md: "1 1 30%", lg: "1 1 22%" },
                        maxWidth: { xs: "100%", sm: "45%", md: "30%", lg: "22%" },
                        height: { xs: 120, sm: 150, md: 200 },
                    }}
                >
                    <ImageSrc style={{ backgroundImage: `url(${image.url})` }} />
                    <ImageBackdrop className="MuiImageBackdrop-root" />
                    <Image>
                        <Typography component="span" variant="subtitle1" color="inherit" sx={{ position: "relative", p: 2 }}>
                            {image.title}
                            <ImageMarked className="MuiImageMarked-root" />
                        </Typography>
                    </Image>
                </ImageButton>
            ))}
        </Box>
    );
}

export default Buttons;